package com.bikompanion.domain

/**
 * A place to lock a bike up — a rack, a stand, a shelter — as OpenStreetMap has it.
 *
 * Nothing here is live: a rack is a piece of street furniture, so unlike a [BikeStation] there
 * are no counts to keep fresh, and a copy months old is still correct.
 *
 * Everything past the position is optional because it is optional in OSM too: most racks are
 * mapped as a bare point, and a field is null where nobody has tagged it rather than where the
 * answer is known to be no.
 */
data class BikeParkingSpot(
    val id: String,
    val latitude: Double,
    val longitude: Double,
    /** How many bikes fit, where somebody has said. */
    val capacity: Int? = null,
    /** Whether it is under cover, where somebody has said. */
    val isCovered: Boolean? = null,
    /** The human-readable address, where someone has tagged it. */
    val address: String? = null,
    /** What it looks like, where somebody has said — [ParkingType.Other] otherwise. */
    val type: ParkingType = ParkingType.Other,
)
